var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Card/CardTitle.js",
    _this = this;

import { getTitle, Thumbnail, TitleWrapper } from './style';
import React from 'react';
import MultilineTruncateParagraph from '../../core/components/MultilineTruncateParagraph';

var CardTitle = function CardTitle(_ref) {
  var thumbnail = _ref.thumbnail,
      fontWeight = _ref.fontWeight,
      showThumbnailBorder = _ref.showThumbnailBorder,
      children = _ref.children;
  var isHeavy = thumbnail || fontWeight === 'heavy';
  var Title = getTitle(isHeavy);
  return /*#__PURE__*/React.createElement(TitleWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 5
    }
  }, thumbnail && /*#__PURE__*/React.createElement(Thumbnail, {
    src: thumbnail.url,
    alt: thumbnail.alt,
    showThumbnailBorder: showThumbnailBorder,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(MultilineTruncateParagraph, {
    Typography: Title,
    numOfLines: 3,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 7
    }
  }, children));
};

export default CardTitle;